{
  "wallboard": {
    "instances_count": "인스턴스 없음 | {count} 인스턴스 | {count} 인스턴스",
    "label": "대시보드"
  }
}
